/**
 * Check if the input is a URL.
 */
export const isUrl = (text: string): boolean => {
  return (
    typeof text === 'string' &&
    (text.startsWith('http://') || text.startsWith('https://'))
  )
}

/**
 * True for all files ending with .yml or .yaml (case-insensitive).
 */
export const isYamlFileName = (fileName: string) => {
  if (isUrl(fileName)) {
    return false
  }

  return /\.ya?ml$/i.test(fileName)
}
